import { useState, useEffect } from "react";

import InboundWelcomeMessageSettings from "./InboundWelcomeMessageSettings";
import OutboundWelcomeMessageSettings from "./OutboundWelcomeMessageSettings";
import { useVoiceSettings } from "../useVoiceSettings";
import TabsWithBadge from "V2.0/common/tabsWithBadge";
import { Button } from "V2.0/common/button";

const TABS = {
  INBOUND: "Inbound",
  OUTBOUND: "Outbound",
};

const Tabs = {
  [TABS.INBOUND]: (props) => <InboundWelcomeMessageSettings {...props} />,
  [TABS.OUTBOUND]: (props) => <OutboundWelcomeMessageSettings {...props} />,
};

export default function WelcomeMessageSettings(props) {
  const {
    welcomeMessageSettings: welcomeMessage,
    syncAssistant,
    workspaceId,
    assistantId,
    locked,
  } = props;
  const { updateVoiceSettings } = useVoiceSettings({
    syncAssistant,
    workspaceId,
    assistantId,
  });

  const [welcomeMessageSettings, setWelcomeMessageSettings] = useState({
    inboundWelcomeMessages: welcomeMessage.inboundWelcomeMessages[0],
    outboundWelcomeMessages: welcomeMessage.outboundWelcomeMessages[0],
    shouldAgentSpeakFirstInbound: welcomeMessage.shouldAgentSpeakFirstInbound,
    shouldAgentSpeakFirstOutbound: welcomeMessage.shouldAgentSpeakFirstOutbound,
  });
  const [activeTab, setActiveTab] = useState(TABS.INBOUND);

  const tabs = Object.values(TABS).reduce((acc, tab) => {
    return [...acc, { name: tab, href: "#", current: tab === activeTab }];
  }, []);

  function handleUpdate(updateWelcomeMessageSetting) {
    setWelcomeMessageSettings((prevSettings) => {
      return {
        ...prevSettings,
        ...updateWelcomeMessageSetting,
      };
    });
  }

  const updateWelcomeMessageSettings = async () => {
    const payload = {
      welcomeMessageSettings,
    };
    updateVoiceSettings(payload);
  };

  return (
    <div className="flex flex-col w-3/5 min-w-[600px] gap-y-2 border rounded-lg m-4">
      <div className="px-6 py-4 bg-gray-50 rounded-t-lg">
        <p className="text-md font-semibold text-gray-900">Welcome Message</p>
        <p className="text-sm mt-1 text-gray-500">
          Configure what the assistant says first when a call is connected
        </p>
      </div>
      <TabsWithBadge
        className="px-4 border-b"
        tabs={tabs}
        onTabChange={(e, { tab }) => setActiveTab(tab.name)}
      />
      <div className="p-4 px-8">
        {Tabs[activeTab]({
          welcomeMessageSettings,
          onUpdate: handleUpdate,
          onSave: updateWelcomeMessageSettings,
          locked,
        })}
      </div>
      <div className="bg-gray-50 px-6 py-3 text-right rounded-b-lg">
        {!locked && (
          <Button onClick={updateWelcomeMessageSettings}>Save</Button>
        )}
      </div>
    </div>
  );
}
